<h2 mat-dialog-title>{{data.title}}</h2>
<div mat-dialog-content class="mat-body-1">
	{{data.body}}
</div>
<div mat-dialog-actions>
	<button mat-button color="accent" [mat-dialog-close]="false">{{data.cancelText}}</button>
	<div fxFlex></div>
	<button mat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>{{data.confirmText}}</button>
</div>
